<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content style="  white-space: pre-line;">
  {{data.message}}
</div>
<div style="float:right;margin:20px;">
  <button style="margin:0px 10px;" mat-raised-button color="accent" type="button" value="Confirm" [mat-dialog-close]="true">Confirm</button>
  <button mat-raised-button color="accent" type="button" value="Cancel" [mat-dialog-close]="false">Cancel</button>
</div>
